module.exports = __webpack_public_path__ + "static/media/YDCM.9bf74076.jpg";